import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Providers } from './providers';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { initializeFirebase, fetchRemoteConfig } from './services/firebase.config';

// Initialize Firebase and fetch remote config
initializeFirebase();
fetchRemoteConfig();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Providers>
          <App />
        </Providers>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
